import React from 'react';
import { Card, CardContent, Box, Typography, Icon } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';
import { androidColors } from '../../theme/androidTheme';

interface OverviewCardProps {
  title: string;
  value: string;
  change: string;
  isPositive: boolean;
  icon: React.ElementType;
  isCompact?: boolean;
}

const OverviewCard: React.FC<OverviewCardProps> = ({
  title,
  value,
  change,
  isPositive,
  icon: IconComponent,
  isCompact = false,
}) => {
  return (
    <Card
      sx={{
        backgroundColor: androidColors.cardBackground,
        border: `1px solid ${androidColors.borderColor}`,
        borderRadius: 3,
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: `0 8px 25px rgba(241, 192, 134, 0.15)`,
        },
      }}
    >
      <CardContent sx={{ p: isCompact ? 2 : 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 2 }}>
          {/* Icône */}
          <Box
            sx={{
              p: 1,
              borderRadius: 2,
              backgroundColor: `${androidColors.primaryGold}20`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <IconComponent
              sx={{
                color: androidColors.primaryGold,
                fontSize: isCompact ? 20 : 24,
              }}
            />
          </Box>

          {/* Badge de changement */}
          <Box
            sx={{
              px: 1.5,
              py: 0.5,
              borderRadius: 3,
              backgroundColor: isPositive 
                ? `${androidColors.success}20`
                : `${androidColors.error}20`,
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
            }}
          >
            <Icon
              component={isPositive ? TrendingUp : TrendingDown}
              sx={{
                color: isPositive ? androidColors.success : androidColors.error,
                fontSize: 16,
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: isPositive ? androidColors.success : androidColors.error,
                fontWeight: 600,
                fontSize: '0.75rem',
              }}
            >
              {isPositive ? '+' : ''}{change}%
            </Typography>
          </Box>
        </Box>

        {/* Titre */}
        <Typography
          variant="body2"
          sx={{
            color: androidColors.textSecondary,
            mb: 0.5,
            fontSize: isCompact ? '0.75rem' : '0.875rem',
          }}
        >
          {title}
        </Typography>

        {/* Valeur */}
        <Typography
          variant={isCompact ? 'h6' : 'h5'}
          sx={{
            color: androidColors.textColor,
            fontWeight: 700,
            fontSize: isCompact ? '1.1rem' : '1.25rem',
          }}
        >
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default OverviewCard;